module.exports = __webpack_public_path__ + "img/people01_01.94352141.png";